
import { mapState } from "vuex"
import AppButton from "@soenergy/frontend-library/src/components/AppButton"
import Article from "@soenergy/frontend-library/src/components/Article"
import pageMixin from "@/mixins/pageMixin"

export default {
  components: { AppButton, Article },
  mixins: [pageMixin],
  asyncData({ $storyblokHelper }) {
    return $storyblokHelper.get({
      id: "website/moving-home",
      version: "2"
    })
  },
  computed: {
    ...mapState({
      isCotMoveOutJourneyEnabled: state =>
        state.contentManagement.isCotMoveOutJourneyEnabled
    }),
    myAccountUrl() {
      return process.env.VUE_APP_ACCOUNT_APP_URL
    }
  }
}
